import React from 'react';
import GuideHomeContainer from '../../../containers/guide/home/GuideHomeContainer';

function GuideHome() {
  return (
    <div className="guidehome">
      <GuideHomeContainer />
    </div>
  );
}

export default GuideHome;
